Service = App.loadClass 'core::Angular/Service'

class exports.PgisService extends Service
    constructor: (@http, @rootScope, @q) ->
        # Container for layers that get added throughout the field definition process
        @added_layers = []

    clipAll: (layer_one, collection, field) ->
        return @http.post 'backend/grower/fields/define/clip-all', {
            layer_one: layer_one,
            collection: collection,
            field: field
        }

    cleanse: (layer) ->
        return @http.post 'backend/grower/fields/define/cleanse', { data: layer }

    geojsonToWkt: (geojson) ->
        return @http.post 'backend/grower/fields/define/geojson-to-wkt', { geojson: geojson }

    removeAddedLayers: () =>
        for layer in @added_layers
            App.map.removeLayer(layer)

    cleanup: () =>
        @setBoundaryLayer(null)
        @setFieldData(null)
        @setZoneObject(null)
        @setProductivityZone(null)
        @setPreviousCropZone(null)
        @setIrrigationZone(null)

    # setters
    setBoundaryLayer: (@boundary_layer) =>
        undefined

    setFieldData: (@field_data) =>
        undefined

    setZoneObject: (@zone_object) =>
        undefined

    adjustBoundaryLayer: (field_data) =>
        if field_data.boundary?
            App.map.removeLayer field_data.boundary if App.map.hasLayer field_data.boundary
        if field_data.boundary_layer?
            App.map.removeLayer field_data.boundary_layer if App.map.hasLayer field_data.boundary_layer
        if @boundary_layer
            App.map.removeLayer @boundary_layer if App.map.hasLayer @boundary_layer

    loadBoundaryLayer: (fit_bound = false) =>
        App.map.addLayer(@boundary_layer) if not App.map.hasLayer(@boundary_layer)
        @fitBounds(@boundary_layer) if fit_bound

    clearBoundaryLayer: () =>
        # only try to remove the layer if it exists
        App.map.eachLayer (l) =>
            if l is @boundary_layer
                App.map.removeLayer(@boundary_layer)

    geojsonToLeaflet: (geojson) =>
        return L.geoJson geojson,
            style: () =>
                return { color: '#0F0', weight: 2 }

    fitBounds: (layer) =>
        App.map.fitBounds(layer.getBounds())

    fieldDataGeoJsonToBoundaryLayer: (field_data, load = false, fit_bound = false) =>
        if load
            @adjustBoundaryLayer(field_data)
        # convert to leaflet layer(s)
        boundary = @geojsonToLeaflet(field_data.boundary)
        # set the boundary layer
        @setBoundaryLayer(boundary)
        if load
            # load the boundary layer if needed
            @loadBoundaryLayer(fit_bound)

    deleteFromLayerStore: (id) =>
        App.layer_store.delete(id)

    getZoneObject: () =>
        return @zone_object

    setIrrigationZone: (@irrigation_zone) =>
        undefined

    setPreviousCropZone: (@previous_crop_zone) =>
        undefined

    setProductivityZone: (@productivity_zone) =>
        undefined

    getIrrigationZone: () =>
        return @irrigation_zone

    getPreviousCropZone: () =>
        return @previous_crop_zone

    getProductivityZone: () =>
        return @productivity_zone

    addZonesToMapIfNeeded: (zone) =>
        # check all areas for the given zone
        for area in zone.zones
            if not App.map.hasLayer(area.visible)
                App.map.addLayer(area.visible)

